import { Box, Typography, useTheme } from '@mui/material';
import Input from 'components/Common/Input';
import { useFormContext } from 'react-hook-form';
import Grid from '@mui/material/Grid2';
import Select from 'components/Common/Select';

export default function CustomizeBehavior() {
  const theme = useTheme();
  const { control } = useFormContext();

  return (
    <Box
      bgcolor={theme.palette.background.paper}
      sx={{ border: '1px solid #F3F3F3' }}
      padding='24px'
      borderRadius='4px'
    >
      <Box
        sx={{
          border: '1px solid #F3F3F3',
          borderRadius: '4px',
          padding: '24px'
        }}
      >
        <Grid container spacing='16px'>
          <Grid size={{ xs: 12, md: 6 }}>
            <Select
              name='agent.agent_type'
              label='Agent type'
              control={control}
              required
              options={[
                {
                  label: 'Customer Service',
                  value: 'customer_service'
                },
                { label: 'Receptionist', value: 'receptionist' },
                { label: 'Order Taker', value: 'order_taker' },
                { label: 'Tech Support', value: 'tech_support' },
                { label: 'Frontend Desk', value: 'frontdesk' },
                { label: 'Reservationist', value: 'reservationist' }
              ]}
            />
            <Typography color='secondary' sx={{ fontSize: '12px' }}>
              Select what will this agent do for you
            </Typography>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <Select
              name='agent.tone'
              label='Tone'
              control={control}
              options={[
                { label: 'Professional', value: 'professional' },
                { label: 'Conversational', value: 'conversational' },
                { label: 'Humorous', value: 'humorous' },
                { label: 'Empathic', value: 'empathic' },
                { label: 'Simple', value: 'simple' },
                { label: 'Academic', value: 'academic' },
                { label: 'Creative', value: 'creative' },
                { label: 'Friendly', value: 'friendly' }
              ]}
              required
            />
            <Typography color='secondary' sx={{ fontSize: '12px' }}>
              Select the tone of your agent
            </Typography>
          </Grid>
          <Grid size={12}>
            <Input name='agent.goal' label='Goal' control={control} fullWidth required multiline minRows={6} />
            <Typography color='secondary' sx={{ fontSize: '12px' }}>
              Tell your agent what is the goal
            </Typography>
          </Grid>
          <Grid size={12}>
            <Input
              name='agent.background'
              label='Background'
              control={control}
              fullWidth
              required
              multiline
              minRows={6}
            />
            <Typography color='secondary' sx={{ fontSize: '12px' }}>
              Explain your agent's background
            </Typography>
          </Grid>
        </Grid>
      </Box>
      <Box sx={{ border: '1px solid #F3F3F3' }} padding='24px' borderRadius='4px' component='form' mt={2}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <Typography variant='h6'>Instructions</Typography>
          {/* <Button>Browse Template</Button> */}
        </Box>
        <Input
          name='agent.instructions'
          label='Instructions'
          control={control}
          multiline
          minRows={6}
          sx={{ marginTop: '26px' }}
          fullWidth
          required
        />
        <Typography color='secondary' sx={{ fontSize: '12px' }}>
          Tell your agent what to do during the conversation
        </Typography>
      </Box>
    </Box>
  );
}
